// Wave UX-2.4 #26 (2026-05-24) — 1기기 정책 안내 배너.
//
// 동작:
//   - useDeviceConfig() 훅 — GET /buyer-app/public/config (no-auth, 5분 캐시)
//   - oneDeviceEnabled=true 일 때만 노출 (false → null 반환)
//
// 정책 토글 시 코드 배포 없이 UI 즉시 반영 — 운영 .env 변경만으로 충분.

import React from 'react';
import { useT } from '../../i18n/I18nProvider';
import { useDeviceConfig } from './deviceConfig';

function DevicePolicyBanner(props) {
  var t = useT();
  var config = useDeviceConfig();

  // 정책 비활성 또는 fetch 실패 시 null 렌더 — DOM 영향 0
  if (!config || !config.oneDeviceEnabled) return null;

  return (
    <div style={{
      background: '#fefce8',
      border: '1px solid #fde68a',
      borderRadius: 12,
      padding: '12px 14px',
      marginBottom: props.marginBottom != null ? props.marginBottom : 16,
      display: 'flex', alignItems: 'flex-start', gap: 10,    }}>
      <span style={{ fontSize: 18, lineHeight: 1.2, color: '#a16207' }}>📱</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#854d0e' }}>{t('devicePolicyTitle')}</div>
        <div style={{ fontSize: 12, color: '#a16207', marginTop: 2, lineHeight: 1.5 }}>{t('devicePolicyBody')}</div>
      </div>
    </div>
  );
}

export default DevicePolicyBanner;
